export default class ChangePasswordValidateDto {
	public originalPassword = '';
	public newPassword = '';

	public constructor(init?: Partial<ChangePasswordValidateDto>) {
        Object.assign(this, init);
    }
}